import type { IOrderPaymentConfirmation } from "@/data/model/Customer";
import type { IOrderApplication } from "@/data/model/OrderApplication";
import type { ITableAllocation } from "@/data/model/Table";

import { logError } from "@/shared/logging/errors";
import type { VueComponentInstance } from "@/shared/utils/vue";

import { Popup } from "@/components/dialog/Popup";

import OrderReceivedPopoverComponent from "@/app/components/payment/OrderReceivedPopover.vue";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class OrderReceivedPopover extends VueContentPopover {
    public onStartOver?: { () };
    public onReceiptAndMore?: { () };
    public onFinish?: { () };

    constructor(options: {
        confirmation: IOrderPaymentConfirmation;
        isWaiterOrAdmin: boolean;
        allocation: ITableAllocation | undefined;
        orderUseCase: IOrderApplication | undefined;
        showReceiptActionsForOperator: boolean;
        uniqueId: string | undefined;
    }) {
        super({ popoverClass: "order-received-popover", flexHeight: true, condensed: true, uniqueId: options.uniqueId });

        try {
            const props = {
                confirmation: options.confirmation,
                isWaiterOrAdmin: options.isWaiterOrAdmin,
                allocation: options.allocation,
                orderUseCase: options.orderUseCase,
                showReceiptActionsForOperator: options.showReceiptActionsForOperator,
                hide: () => this.hide(),
                updateBodyHeight: () => this.updateBodyHeight(),
                onStartOver: () => {
                    if (this.onStartOver) {
                        this.onStartOver();
                    }
                },
                onReceiptAndMore: () => {
                    if (this.onReceiptAndMore) {
                        this.onReceiptAndMore();
                    }
                },
                onFinish: () => {
                    if (this.onFinish) {
                        this.onFinish();
                    }
                },
            };
            this.initComponent(OrderReceivedPopoverComponent, props);
        } catch (ex) {
            logError(ex);
            Popup.show({ message: "Error showing done popover" });
            this.hide();
        }
    }

    public refreshUseCaseSection() {
        const component = this.componentInfo?.mountedComponent as VueComponentInstance<typeof OrderReceivedPopover>;
        component?.refreshUseCaseSection();
    }
}
